// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";


// import About from "./Componants/About";
// import Services from "./Componants/Services1";
// import Contact from "./Componants/Contact";
// import Footer from "./Componants/Footer1";
// import Experience from "./Componants/Experience1";
// import Intro from "./Componants/Intro1";
// import ScrollTop from "./ScrollTop";
// import WhyChoose from "./Componants/WhyChoose1";
// import HomeTechnologies from "./Componants/Tech1";
// import Web from "./Componants/Services/web";
// import MobileDevelopment from "./Componants/Services/Mob";
// import Ecommerce from "./Componants/Services/ECommerce";
// import Salesforce from "./Componants/Services/Saleforce";
// import StaffAugmentation from "./Componants/Services/StaffAug";
// import Header1 from "./Componants/Header1";

// function Main2() {
//   return (
//     <Router>
//       {/* Header always visible */}
//       <ScrollTop/>
//       {/* <Header1 /> */}

//       {/* Pages rendered below header */}
//       <div className="pt-22"> {/* padding top = header height */}
//         <Routes>
//           {/* Only show Intro on /home */}
//           <Route path="/home" element={<Intro />} />
//           <Route path="/about" element={<About />} />
//           <Route path="/services" element={<Services />} />
//           <Route path="/contact" element={<Contact />} />
//           <Route path="/experience" element={<Experience />} />
//           <Route path="/whychoose" element={<WhyChoose />} />
//           <Route path="/web" element={<Web/>}/>
//            <Route path="/mob" element={<MobileDevelopment/>}/>
//             <Route path="/ecom" element={<Ecommerce/>}/>
//              <Route path="/salesforce" element={<Salesforce/>}/>
//              <Route path="/staff" element={<StaffAugmentation/>}/>

//           {/* Default route: redirect to /home */}
//           <Route path="/technology" element={< HomeTechnologies/>} />
//                 {/* Default route: redirect to /home */}
//         <Route path="*" element={<Navigate to="/home" />} />
//         </Routes>
//       </div>

//       <Footer />
//     </Router>
//   );
// }

// export default Main2;


import { Routes, Route, Navigate } from "react-router-dom";
import ScrollTop from "./ScrollTop";

// All Pages for Main2 (Dark Theme Version)
import Intro from "./Componants/Intro1";
import About from "./Componants/About";
import Services from "./Componants/Services1";
import Contact from "./Componants/Contact";
import Experience from "./Componants/Experience1";
import WhyChoose from "./Componants/WhyChoose1";
import HomeTechnologies from "./Componants/Tech1";

// Services inside Main2
import Web from "./Componants/Services/web";
import MobileDevelopment from "./Componants/Services/Mob";
import Ecommerce from "./Componants/Services/ECommerce";
import Salesforce from "./Componants/Services/Saleforce";
import StaffAugmentation from "./Componants/Services/StaffAug";
import Footer from "./Componants/Footer1";

export default function Main2() {
  return (
    <div className="pt-0">
      <ScrollTop />

      <Routes>
        <Route path="/home" element={<Intro />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/whychoose" element={<WhyChoose />} />
        <Route path="/technology" element={<HomeTechnologies />} />

        {/* Services */}
        <Route path="/web" element={<Web />} />
        <Route path="/mob" element={<MobileDevelopment />} />
        <Route path="/ecom" element={<Ecommerce />} />
        <Route path="/salesforce" element={<Salesforce />} />
        <Route path="/staff" element={<StaffAugmentation />} />

        {/* Default Redirect */}
        <Route path="*" element={<Navigate to="/home" />} />
      </Routes>
      <Footer/>
    </div>
  );
}
